import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from './api.service';
import { ApiResponse } from '../models/api-response';
import { StatementRequest } from '../models/statement-request';
import { StatementResponse } from '../models/statement-response';

@Injectable({ providedIn: 'root' })
export class StatementService {
  constructor(private api: ApiService) {}

  createStatement(request: StatementRequest): Observable<StatementResponse> {
    return this.api.post<ApiResponse<StatementResponse>>('/statements', request).pipe(
      map(res => {
        if (!res.data) {
          throw new Error(res.message || 'Statement creation did not return data');
        }
        return res.data;
      })
    );
  }

  uploadStatementFile(statementId: string, file: File): Observable<StatementResponse> {
    const formData = new FormData();
    formData.append('file', file);

    return this.api.postFormData<ApiResponse<StatementResponse>>(`/statements/${statementId}/upload`, formData).pipe(
      map(res => {
        if (!res.data) {
          throw new Error(res.message || 'Statement upload did not return data');
        }
        return res.data;
      })
    );
  }

  listStatements(): Observable<StatementResponse[]> {
    return this.api.get<ApiResponse<StatementResponse[]>>('/statements').pipe(
      map(res => res.data ?? [])
    );
  }

  getStatement(id: string): Observable<StatementResponse> {
    return this.api.get<ApiResponse<StatementResponse>>(`/statements/${id}`).pipe(
      map(res => {
        if (!res.data) {
          throw new Error(res.message || 'Statement lookup did not return data');
        }
        return res.data;
      })
    );
  }

  deleteStatement(id: string): Observable<void> {
    return this.api.delete<ApiResponse<void>>(`/statements/${id}`).pipe(
      map(() => void 0)
    );
  }
}
